<nav class="stepper d-flex">
    <ol class="stepper-list d-flex align-items-center justify-content-between w-100">
        <li class="stepper-item"
            *ngFor="let step of templatesArray?.data; let i = index; let isLast = last; let isFirst = first;"
            [ngClass]="{'is-passed': i < index, 'is-current' : i == index, 'is-active' : i < index, 'is-last': isLast, 'is-first': isFirst }">
            <div class="stepper-nav__link"></div>
            <div class="stepper-nav__title" [innerHTML]="titles[i].title">
            </div>
        </li>
    </ol>
</nav>
<div *ngFor="let step of templatesArray?.data; let i = index;">
    <div class="c-stepper-nav__content" *ngIf="states[i]">
        <ng-container *ngTemplateOutlet="step"></ng-container>
    </div>
</div>